module.exports = __webpack_public_path__ + "img/img14.7c3ee01e.png";